const cookies = () => {
    setTimeout(function(){
        if ($.cookie('msgcookie') === null || $.cookie('msgcookie') === "" || $.cookie('msgcookie') === "null" || $.cookie('msgcookie') === undefined) {
            $('.cookiepolicy').css('display', 'block').addClass('animated slideInUp');
        }
    }, 3000);
    
    $('.cookiepolicy a').on('click', function(e) {
        e.preventDefault();
        $(this).parent('.cookiepolicy').removeClass('slideInUp').addClass('slideOutDown');
        $.cookie('msgcookie', 'msgcookie', {
            expires: 365,
            path: '/'
        });
    });
 }
 
 module.exports = {
    cookies, 
 };